import React from 'react';

function AuthLayout({ children }) {
  return (
    <div
      className="d-flex justify-content-center flex-column align-items-center bg-blue-1"
      style={{ height: '100vh', fontSize: 20, fontWeight: '700' }}>
      {children}
    </div>
  );
}

export default AuthLayout;
